export const TICKET_STATUSES = {
    0: 'Open',
    1: 'Pending',
    2: 'Resolved',
    3: 'Closed',
    4: 'Waiting on Client',
    5: 'Waiting on Third Party',
    6: 'New'
};

export const TICKET_PRIORITIES = {
    0: 'Low',
    1: 'Medium',
    2: 'High',
    3: 'Urgent'
};

export const TICKET_DIFFICULTIES = {
    1: '1 - Very Low',
    2: '2 - Low',
    3: '3 - Medium',
    4: '4 - High',
    5: '5 - Very High'
};

export default {
    getHumanReadableTicketStatus(status) {
        return TICKET_STATUSES[status];
    },
    getHumanReadableTicketPriority(priority) {
        return TICKET_PRIORITIES[priority];
    },
    getHumanReadableTicketDifficulty(difficulty) {
        return TICKET_DIFFICULTIES[difficulty];
    }
}